import { axiosV3 } from "../../Utils/Axios/axiosV3";
export const getBeginPageImageService = async () => {
  return axiosV3.get("/get-beginning-image");
};
